/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { isDevMode } from '@angular/core';
import { ServiceWorkerModule } from '@angular/service-worker';

// Add service worker to app config if not already present
const serviceWorkerConfig = ServiceWorkerModule.register('ngsw-worker.js', {
	enabled: !isDevMode(),
	registrationStrategy: 'registerImmediately',
});

// Ensure service worker is imported in providers
appConfig.providers.push(...serviceWorkerConfig.providers || []);

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
